<template>
  <div>
    <Subtitles v-if="subtitle && narration.id" :key="narration.id" :subtitles="chapter.audio.subtitles[narration.name]" :name="narration.name" />
    <!-- <Debugger ref="debugger"/> -->
  </div>
</template>

<script>
import { Howl, Howler } from 'howler'
import Subtitles from './Subtitles'
// import Debugger from '@/components/debugger/Debugger'

export default {
  name: 'Biorythme',
  components: { Subtitles },
  beforeDestroy() {
    this.$tl.kill()
    if(this.$root.isModeVideo) this.chapter.$video.removeEventListener('timeupdate', this.timeUpdate)
    // document.removeEventListener('visibilitychange', this.checkVisibility)
    // window.removeEventListener('focus', this.focus)
    // window.removeEventListener('blur', this.blur)
    if(this.chapter.$howler) {
      _.each(this.chapter.$howler._sounds, sound => this.fade(sound._id, 0, true))
      // this.$killDelay = TweenLite.delayedCall(4, () => {
      //   this.chapter.$howler.unload()
      //   this.chapter.$howler = null
      // })
    }
  },
  computed: {
    subtitle() { return this.$store.getters['app/subtitle'] },
  },
  watch: {
    $route() {
      if(this.stopped) return
      else this.playPauseChecker(this.$route.meta.name != 'chapters' ? 'pause' : 'play')
    },
    '$root.orientation'(nw, od) {

      if(nw == 'landscape') this.fadeOutAmbience()
      else this.fadeInAmbience()

      if(nw == 'landscape' && !this.stopped) 
        this.pauseTimelineAndNarration()  
      else if(nw == 'portrait' && this.paused && this.$route.meta.name != 'menu' && this.chapter.$tl.time() != 0) 
        this.playTimelineAndNarration()
          
    },
  },
  data: () => ({
    chapter: null,
    narration: {
      id: false,
      name: null,
      duration: 0
    },
    stopped: false,
    cue: 0,
    points: [],
    paused: false,
    rythme_name: null,
    tweens: {}

  }),
  created() {
    
    if(this.$killDelay)
      this.$killDelay.kill()

    this.chapter = _.find(this.chapters, chapter => chapter[this.lang].slug == this.$route.params.chapter)

    if(!this.chapter.$howler)
      this.chapter.$howler = new Howl({
        html5: false,
        src: [this.chapter.audio.mp3],
        sprite: this.chapter.audio.json.sprite,
        volume: 0,
      })

    _.each(this.chapter.audio.ambiences, (name, key) => {
      const id = this.chapter.$howler.play(key)
      this.chapter.$howler.volume(0, id)
      this.chapter.audio.ambiences[key] = id
    })

    this.$tl = new TimelineMax({ id: 'Biorythme' })

    _.each(this.chapter.biorythme, rythme => {
      
      if(rythme.type == 'narration') {
        if(this.chapter.key == 'senate' && rythme.name == 'A_NAR_02'
        || this.chapter.key == 'senate' && rythme.name == 'ARCH_01'
        || this.chapter.key == 'senate' && rythme.name == 'A_NAR_03'
        || this.chapter.key == 'house_of_commons' && rythme.name == 'ARCH_01'
        || this.chapter.key == 'peace_tower' && rythme.name == 'NAR_02' ) {
          console.log('nothing for '+ this.chapter.key +' - '+ rythme.name)
        }
        else 
          this.chapter.$tl.addLabel(rythme.name, rythme.start_at_seconds)
      }

      if(rythme.type == 'stop') {
        const sc = (this.chapter.key == 'peace_tower' && rythme.start_at_seconds == 33) ? 34 : rythme.start_at_seconds
        this.points.push(sc)
      }

      this.$tl
        .call(() => {
          this.setStatusType(rythme)
          if(rythme.type == 'stop') return this.stop()
          if(rythme.type == 'ambience') this.playAmbience(rythme.name)
          if(rythme.type == 'narration') this.playNarration(rythme.name)
          if(rythme.type == 'end') return this.moveToNextChapter()
        }, undefined, undefined, rythme.start_at_seconds)

      if(rythme.type == 'ambience' && rythme.start_at_seconds == 0) 
        this.playAmbience(rythme.name)
    })

    this.chapter.$tl.add(this.$tl, 0)

    if(this.$root.speedMode)
      this.chapter.$tl.timeScale(this.$root.speed)
  },
  mounted() {
    this.$tl.time(this.chapter.$tl.time())

    // document.addEventListener('visibilitychange', this.checkVisibility)
    // window.addEventListener('focus', this.focus)
    // window.addEventListener('blur', this.blur)

    // this.$refs.debugger.useDebugger('debugger') 

    if(this.$root.isModeVideo)
      this.chapter.$video.addEventListener('timeupdate', this.timeUpdate)
  },
  methods: {

    unStopped() {
      this.playPauseChecker('play', 'in') 
    },

    forceStoppped() {
      this.playPauseChecker('pause', 'out')
    },
    focus() { 
      // this.$refs.debugger.useDebugger('focus') 
      this.playPauseChecker('play') 
    },
    blur() {
      // this.$refs.debugger.useDebugger('blur') 
      this.playPauseChecker('pause')
    },

    timeUpdate() {
      const time = Math.round(this.chapter.$video.currentTime)
      if(time < this.points[this.cue-1]) {
        this.cue -= 1
      }
      if(time == this.points[this.cue]) {
        this.chapter.$video.pause()
        this.cue += 1
      }
    },
    playPauseChecker(action, fade) {
      if(this.chapter.key == '"introduction"' || this.$root.orientation == 'landscape' && this.$root.isModeVideo) return
      if(action == 'pause' || fade == 'out') this.fadeOutAmbience()
      else if(action == 'play' || fade == 'in')this.fadeInAmbience()
      if(this.chapter.$tl._time == 0) return
      if(action == 'pause'){
        if(!this.stopped) 
          this.pauseTimelineAndNarration()
      } 
      if(action == 'play'){
        if(this.paused)
          this.playTimelineAndNarration()
      } 
    },
    checkVisibility() {
      // this.$refs.debugger.useDebugger('checkvisibility')  
      // this.playPauseChecker(document.visibilityState === 'hidden' ? 'pause' : 'play')

      if(document.visibilityState === 'hidden')
        this.playPauseChecker('pause')
    },

    getTime() {
      if(this.$root.isModeVideo) 
        return this.chapter.$video.currentTime
      else 
        return this.chapter.$tl._time 
    },

    playTimelineAndNarration() {
      this.paused = false
      this.chapter.$tl.play()
      if(this.narration.id) 
        this.chapter.$howler.play(this.narration.id)
      if(this.$root.isModeVideo) 
        this.chapter.$video.play()
    },
    pauseTimelineAndNarration() {
      this.paused = true
      this.chapter.$tl.pause()
      if(this.narration.id) 
        this.chapter.$howler.pause(this.narration.id)
      if(this.$root.isModeVideo) 
        this.chapter.$video.pause()
    },
    setStatusType(rythme) {
      this.$parent.tl.rythme.name = rythme.name
      this.$parent.tl.rythme.type = rythme.type
    },
    moveToNextChapter: async function() {

      if(this.$root.isModeVideo) 
        this.chapter.$video.pause()
      
      await this.$parent.$refs.chapter_outro.start()
      const index  = _.findIndex(this.chapters, c => c.id == this.chapter.id)
      const nextIndex = this.chapters.length - 1 == index ? 0 : index + 1
      this.$router.push({ name: 'chapters.' + this.lang, params: { chapter: this.chapters[nextIndex][this.lang].slug } })
    },
    stop() {

      this.stopped = true
      this.chapter.$tl.pause()
      if(this.narration.id) this.chapter.$howler.stop(this.narration.id)
      // if(this.$root.isModeVideo) this.chapter.$video.pause()
    },
    fade(id, to, stop) {

      // console.log(this.chapter.$howler._sounds);
      // console.log(id, to, stop);
      // console.log(this.chapter.$howler);
      const sound = _.find(this.chapter.$howler._sounds, s => s._id == id)
      // console.log(sound);
      // console.log('xxxxxxxxxxxxxxxx');

      if(sound == undefined)
        return

      const volume = { x: sound._volume }
      // console.log(volume);

      this.tweens[id] = TweenLite.to(volume, .25, {
        x: to,
        onUpdate: () => {
          this.chapter.$howler.volume(volume.x, id)
        },
        onComplete: () => {
          if(stop)
            this.chapter.$howler.stop(id)
        }
      })
    },
    playAmbience(mergedname) {
      this.rythme_name = mergedname
      const ambienceToFadeIn = mergedname.split('.')
      _.each(this.chapter.audio.ambiences, (id, name) => {
        ambienceToFadeIn.indexOf(name) > -1
        ? this.fade(id, 1)
        : this.fade(id, 0)
      })
    },
    fadeInAmbience() {
      if(this.rythme_name)
        this.playAmbience(this.rythme_name)
    },
    fadeOutAmbience() {
      _.each(this.chapter.audio.ambiences, (id, name) => {
        if(this.tweens[id])
          this.tweens[id].kill()
        this.chapter.$howler.volume(0, id)
      })
    },
    playNarration(name) { 
      if(this.narration.id)
        this.chapter.$howler.stop(this.narration.id)
      this.stopped = false
      name = this.lang.toUpperCase() + '_' + name
      const id = this.chapter.$howler.play(name)
      this.chapter.$howler.volume(1, id)
      this.narration.id = id
      this.narration.name = name
      this.narration.duration = this.chapter.$howler.duration(id)
    },
  }
}
</script>
